function LoadScript(id, script) {
  const existingScript = document.getElementById(id);

  if (existingScript) {
    return Promise.resolve(id, script);
  }

  const scriptElement = document.createElement("script");
  scriptElement.id = id;
  scriptElement.src = script;
  scriptElement.async = true;
  // Same CORS mode as the Plumage tour templates: a no-cors load caches the CDN response without
  // Access-Control-Allow-Origin, and the browser reuses it for their crossorigin load, which then fails.
  scriptElement.crossOrigin = "anonymous";

  const promise = new Promise((resolve, reject) => {
    scriptElement.addEventListener("load", () => resolve(id, script));
    scriptElement.addEventListener("error", e => reject(e));
  }).catch(e => {
    scriptElement.remove();
    throw e;
  });

  document.body.appendChild(scriptElement);

  return promise;
}

export default LoadScript;
